import { quizzes, getQuizById as getOriginalQuizById } from "../mocks/quizzes";
import type { Quiz } from "../mocks/quizzes";
import { rpgQuizzes } from "../mocks/quizzes-rpg";
import { sandboxQuizzes } from "../mocks/quizzes-sandbox";
import { actionQuizzes } from "../mocks/quizzes-action";
import { entertainmentQuizzes } from "../mocks/quizzes-entertainment";
import { moviesQuizzes } from "../mocks/quizzes-movies";
import { animeQuizzes } from "../mocks/quizzes-anime";
import { loveQuizzes } from "../mocks/quizzes-love";
import { animalsQuizzes } from "../mocks/quizzes-animals";

export type { Quiz };

export const allQuizzes: Quiz[] = [
  ...quizzes,
  ...(rpgQuizzes as unknown as Quiz[]),
  ...(sandboxQuizzes as unknown as Quiz[]),
  ...(actionQuizzes as unknown as Quiz[]),
  ...(entertainmentQuizzes as unknown as Quiz[]),
  ...(moviesQuizzes as unknown as Quiz[]),
  ...(animeQuizzes as unknown as Quiz[]),
  ...(loveQuizzes as unknown as Quiz[]),
  ...(animalsQuizzes as unknown as Quiz[]),
];

export function getAllQuizById(id: string): Quiz | undefined {
  return allQuizzes.find((q) => q.id === id);
}

export function getAllQuizzesByCategory(category: string): Quiz[] {
  return allQuizzes.filter((q) => q.category === category);
}

export const allFeaturedQuizzes = allQuizzes.slice(0, 4);
